import { ref, watch } from 'vue'

export function useMapSounds() {
  // Sound refs
  let geigerSound = null
  let sonarSound = null
  let beepSound = null
  let radarSound = null
  const soundMode = ref(localStorage.getItem('tinygs-sound-mode') || 'radar')

  // Watch for sound mode changes and save to localStorage
  watch(soundMode, (newMode) => {
    localStorage.setItem('tinygs-sound-mode', newMode)
  })

  // Initialize sounds
  function initializeSounds() {
    try {
      geigerSound = new Audio('/sounds/geiger-click.mp3')
      geigerSound.volume = 0.4

      sonarSound = new Audio('/sounds/sonar-ping.mp3')
      sonarSound.volume = 0.3

      beepSound = new Audio('/sounds/beep.mp3')
      beepSound.volume = 0.4

      radarSound = new Audio('/sounds/radar-ping.mp3')
      radarSound.volume = 0.3
    } catch (e) {
      console.error("Could not initialize audio:", e)
    }
  }

  // Play sound based on current mode
  function playSound() {
    switch (soundMode.value) {
      case 'geiger':
        if (geigerSound) {
          geigerSound.currentTime = 0
          geigerSound.play().catch(e => console.warn("Audio playback failed.", e.name))
        }
        break
      case 'sonar':
        if (sonarSound) {
          sonarSound.currentTime = 0
          sonarSound.play().catch(e => console.warn("Audio playback failed.", e.name))
        }
        break
      case 'beep':
        if (beepSound) {
          beepSound.currentTime = 0
          beepSound.play().catch(e => console.warn("Audio playback failed.", e.name))
        }
        break
      case 'radar':
        if (radarSound) {
          radarSound.currentTime = 0
          radarSound.play().catch(e => console.warn("Audio playback failed.", e.name))
        }
        break
      // 'off' mode does nothing
    }
  }

  return {
    soundMode,
    initializeSounds,
    playSound
  }
}